{
  "LoadingLabel": "[Wird geladen...]",
  "NAME": "ComboBox"
}